/*
===============================================================================================================
                                 Copyright 2022-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import apiClient from '@/utilities/api-client';
import statuses from './statuses';

const sendEmail = async ({
  requestData,
  templateId,
  orgId,
  authTokenString,
  emailAddress,
  setStatus,
}) => {
  const emailUrl = `${orgId}/send-email/${templateId}`;

  const substitutedData = JSON.stringify(requestData)?.replaceAll('%EMAIL%', emailAddress);

  try {
    await apiClient.post(
      emailUrl,
      JSON.parse(substitutedData),
      authTokenString ? {
        headers: {
          Authorization: authTokenString,
        },
      } : undefined,
    );
    setStatus(statuses.SENT);
  } catch (exception) {
    setStatus(statuses.FAILED);
  } finally {
    setTimeout(() => setStatus(statuses.NONE), 2000);
  }
};

export default sendEmail;
